export default "__VITE_ASSET__55570798__"